export default () => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    maxWidth: 360,
    boxShadow: 'none',
    borderRadius: 20,
    background: '#FFF',
    display: 'inline-flex',
    flexDirection: 'column',
    padding: 20,
    gap: 16,
    position: 'relative',
    margin: 20,
    width: '100%',
  },
  header: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 8,
    borderBottom: '1px solid rgba(202, 196, 208, 0.50)',
  },
  closeButton: {
    padding: 4,
  },
  title: {
    color: '#49454F',
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '27px',
    letterSpacing: 0.5,
  },
  content: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
  },
  text: {
    color: '#49454F',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '22px',
  },
});
